function wowo($) {
  setTimeout(function () {
    jQuery("html").addClass("show-c");
    var wTop = jQuery(window).scrollTop(),
      wHeight = jQuery(window).height(),
      wBottom = wTop + wHeight;
    jQuery(".wowo:not(.animated)").each(function () {
      var me = jQuery(this),
        meTop = me.offset().top,
        meHeight = me.height(),
        meBottom = meTop + meHeight,
        limitTop = wTop - meHeight,
        limitBottom = wBottom + meHeight;
      if (meTop > limitTop && meBottom < limitBottom) {
        me.addClass("animated");
        setTimeout(function () {
          // me.removeClass("wowo");
        }, 2000);
      }
    });

    jQuery(".paralax-insta:not(.animated)").each(function () {
      var me = jQuery(this),
        meTop = me.offset().top,
        meHeight = me.height(),
        meBottom = meTop + meHeight,
        limitTop = wTop - meHeight,
        limitBottom = wBottom + meHeight;

      if (meTop > limitTop && meBottom < limitBottom) {
        for (var i = 1; i <= 8; i++) {
          me.find(".paralax__image.image-" + i).addClass(" animated myAnimation_" + i);
        }
        for (var i = 1; i <= 10; i++) {
          me.find(".paralax__title.title-" + i).addClass(" animated titleAnimation_" + i);
        }
        me.find(".paralax__image-logo.image-7").addClass(" animated myAnimation_7");
        me.find(".paralax__image-logo.image-8").addClass(" animated myAnimation_8");
        setTimeout(function () {
          // me.removeClass("animated wowo");
        }, 5000);
      }
    });
  }, 100);
}

function scroll() {
  $(".parallax").eq(1).addClass("style-1");
  $(".parallax:last").addClass("style-1");
  jQuery(window).scroll(function () {
    var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    // var ele_height = jQuery(".header").innerHeight();
    var ele_height = $(window).width() > 575 ? 40 : 32;
    var topBarHeight = $(".header__top-bar").innerHeight();
    if (scrollTop > ele_height) {
      jQuery("header").addClass("sticky");
      $(".header__top-bar").addClass("flag__sticky");
      if (!$(".header__top-bar").hasClass("flag__close")) {
        $(".header__top-bar").css("margin-top", -topBarHeight);
      }
    } else {
      jQuery("header").removeClass("sticky");
      $(".header__top-bar").removeClass("flag__sticky");
      if (!$(".header__top-bar").hasClass("flag__close")) {
        $(".header__top-bar").css("margin-top", 0);
      }
    }

    var wh = jQuery(window).height();
    var sh = jQuery(window).scrollTop();

    if ($("#rap__med__insta").length) {
      jQuery("#rap__med__insta > div").each(function () {
        var parallax_h = jQuery(this).offset().top;
        if (sh > parallax_h - wh) {
          var parallax_y = -(sh - (parallax_h - wh)) / 8;
          $(this).css("transform", "translateY(" + parallax_y + "px)");
        }
      });

      // var parallax_h1 = jQuery(".parallax.style-1").offset().top;
      // if (sh > parallax_h1 - wh) {
      //   var parallax_y = -(sh - (parallax_h1 - wh)) / 6;
      //   jQuery(".parallax.style-1").css("transform", "translateY(" + parallax_y + "px)");
      // }
    }

    // var parallax_h2 = jQuery(".parallax.style-2").offset().top;
    // if (sh > parallax_h2 - wh) {
    //   var parallax_y = -(sh - (parallax_h2 - wh)) / 6;
    //   jQuery(".parallax.style-2").css("transform", "translateY(" + parallax_y + "px)");
    // }
    if ($(".ms-redheads-block").length) {
      var offsetTop = $(".ms-redheads-block").offset().top;
      var heightEle = $(".ms-redheads-block").innerHeight();
      var headerHeight = $(".header").innerHeight();
      var wh = $(window).height();
      var scrollSpeedFactor;

      if ($(window).width() >= 1680) {
          scrollSpeedFactor = 2; 
      } else if ($(window).width() >= 1440) {
          scrollSpeedFactor = 4; 
      }  else if ($(window).width() >= 575) {
        scrollSpeedFactor = 5; 
    } else {
          scrollSpeedFactor = 4; 
      }
  
      if (scrollTop + wh > offsetTop + 2 *heightEle / 3  && scrollTop < offsetTop + heightEle) {
        var scrollLeft = (scrollTop + wh - offsetTop - 2 *heightEle / 3) * scrollSpeedFactor;
        $(".ms-redheads-block h2").css("transform", "translateX(-" + scrollLeft + "px)");
  
      }
    }

    // $(window).width() <
  });

  $('#rap__med__insta_title a').click(function (e) {
    e.preventDefault();
    e.stopPropagation();
  } )
}

function cookie() {
  if (jQuery(".pop-up").length > 0) {
    if (jQuery.cookie("open-pop-up")) {
      jQuery(".pop-up").removeClass("active");
    } else {
      jQuery(".pop-up").addClass("active");
    }
    jQuery.cookie("open-pop-up", "email-open", {
      expires: 1,
      path: "/",
    });

    $(".pop-up .icon-close").click(function () {
      jQuery(".pop-up").removeClass("active");
    });
    $('.header__top-bar p').click(function (e) {
      e.stopPropagation();
      jQuery(".pop-up").addClass("active");
    });
  }
}

function video() {
  jQuery(".video-link.mp4,.is-video").click(function (event) {
    event.preventDefault();
    jQuery(document).bind("mousewheel DOMMouseScroll", function (event) {
      event.preventDefault();
    });
    jQuery(document).bind("touchmove", function (event) {
      event.preventDefault();
    });

    var video_url = jQuery(this).find(".data-video").html();
    jQuery(".video-light-box")
      .find(".play-iframe-video")
      .append('<video  muted loop="loop" controls="controls"><source src="' + video_url + '" type="video/mp4"></video>');
    jQuery(".video-light-box").fadeIn(300);

    var videoElements = jQuery(".video-light-box video");
    var hls = new Hls();
    videoElements.each(function () {
      var videoSrc = jQuery(this).find("source").attr("src");
      var videoElement = this;
      if (videoSrc.endsWith(".mp4")) {
      } else {
        hls.loadSource(videoSrc);
        hls.attachMedia(videoElement);
      }
    });
  });
  jQuery(".video-link.file").click(function (event) {
    event.preventDefault();
    jQuery(document).bind("mousewheel DOMMouseScroll", function (event) {
      event.preventDefault();
    });
    jQuery(document).bind("touchmove", function (event) {
      event.preventDefault();
    });
    var video_url = jQuery(this).find(".data-video").html();
    var caption = jQuery(this).find(".data-video").attr("data-caption");
    jQuery(".video-light-box")
      .find(".play-iframe-video")
      .append('<video controls="controls"><source src="' + video_url + '" type="video/mp4"> <track src="' + caption + '"  srclang="en" label="English" kind="subtitles" default /></video>');
    jQuery(".video-light-box").fadeIn(300);
  });
  jQuery(".video-link.embed").click(function (event) {
    event.preventDefault();
    jQuery(document).bind("mousewheel DOMMouseScroll", function (event) {
      event.preventDefault();
    });
    jQuery(document).bind("touchmove", function (event) {
      event.preventDefault();
    });
    jQuery(".video-light-box").fadeIn(300);
    var html = jQuery(this).find(".data-video").html();
    console.log(html);
    jQuery(".video-light-box").find(".play-iframe-video").html(html);
  });

  jQuery(".video-light-box .icon-close").click(function () {
    jQuery(document).unbind("mousewheel DOMMouseScroll");
    jQuery(document).unbind("touchmove");
    jQuery(".video-light-box").fadeOut(300);
    setTimeout(function () {
      jQuery(".video-light-box").find(".play-iframe-video").html("");
    }, 300);
  });

  jQuery(".video-light-box").click(function () {
    jQuery(document).unbind("mousewheel DOMMouseScroll");
    jQuery(document).unbind("touchmove");
    jQuery(".video-light-box").fadeOut(300);
    setTimeout(function () {
      jQuery(".video-light-box").find(".play-iframe-video").html("");
    }, 300);
  });
  jQuery(".video-light-box .video-box").click(function (event) {
    event.stopPropagation();
  });

  jQuery(".video-link,.is-video").click(function (event) {
    event.stopPropagation();
    var vvv = jQuery(this).children(".video").find("video");
    vvv.on("loadedmetadata", function () {
      vvv.trigger("play");
    });
    // vvv.trigger('play');

    setTimeout(function () {
      var ss = jQuery(".video-light-box .video-box video");
      ss.trigger("play");
    }, 300);
  });

  jQuery(".video-show").click(function (event) {
    event.stopPropagation();
    jQuery(this).children(".text-and-img").addClass("is-active");
    var vvv = jQuery(this).parents(".video").find("video");

    if (jQuery(this).hasClass("is-active")) {
      vvv.trigger("play");
      jQuery(this).removeClass("is-active");
    } else {
      jQuery(this).addClass("is-active");
      vvv.trigger("pause");
    }
  });
}

function hlsVideo() {
  // var videoElements = document.querySelectorAll("video");

  var videoElements = document.querySelectorAll("video");

  videoElements.forEach(function (videoElement) {
    var videoSrc = videoElement.getAttribute("src");

    if (videoSrc && videoSrc.endsWith(".mp4")) {
    } else {
      var hls = new Hls();
      hls.loadSource(videoSrc);
      hls.attachMedia(videoElement);
    }
  });
}

function insta() {
  if (jQuery("#instafeed").length > 0) {
    var InstagramToken = $("#instafeed").attr("data-key");
    var link = $("#instafeed").attr("data-link");
    var feed = new Instafeed({
      accessToken: InstagramToken,
      limit: 6,
      template: '<div class="paralax__image ">  <div style="background-image:  url({{image}})"></div></div>',
      after: function () {
        jQuery(".paralax__image").each(function () {
          var i = jQuery(this).index() + 1;
          jQuery(this).addClass(" image-" + i + "");
        });

        wowo();
      },
    });
    feed.run();
  }
}

function resizeWindow() {
  var header_h = jQuery(".header").height();
  var window_h = jQuery(window).height();
  if ($("body").hasClass("innerPage")) {
    $("#MainContent").css("padding-top", header_h);
  }

  jQuery(window).resize(function () {
    var header_h = jQuery(".header").height();
    var window_h = jQuery(window).height();
    if ($("body").hasClass("innerPage")) {
      $("#MainContent").css("padding-top", header_h);
    }
  });
  $(window).scroll(function () {
    var header_h = jQuery(".header").height();
    var window_h = jQuery(window).height();
    if ($("body").hasClass("innerPage")) {
      $("#MainContent").css("padding-top", header_h);

      setTimeout(() => {
        var header_h = jQuery(".header").height();
        $("#MainContent").css("padding-top", header_h);
      }, 300);
    }
  });
}

function dataOrder() {
  var colsClone = $(".our-story .cols").clone();
  $(".our-story .content").append("<div class='cloned-items'></div>");
  $(".our-story .cloned-items").append(colsClone);

  var data_items = $(".our-story .cloned-items .cols .col-item").toArray();
  data_items.sort((a, b) => {
    const timeA = parseFloat($(a).find(".data-time").text());
    const timeB = parseFloat($(b).find(".data-time").text());
    return timeA - timeB;
  });
  $(".our-story .cloned-items").empty().append(data_items);
  $(window).resize(function () {
    if ($(window).width() < 991) {
      $(".our-story .cloned-items").empty().append(data_items);
    }
  });
}
function parallax() {
  var sh = jQuery(window).scrollTop();
  var wh_ha = jQuery(window).height() / 3;

  jQuery(".parallax").each(function () {
    var parallax_h = jQuery(this).offset().top;
    if (sh > parallax_h - wh_ha) {
      var parallax_y = (sh - (parallax_h - wh_ha)) / 8;
      jQuery(this).css("transform", "translate3d(0px,-" + parallax_y + "px, 0px)");
    }
  });
}

function hoverFun() {
  $(".top-level-item").eq(0).addClass("active").find(".children-panel").fadeIn();

  $(".top-level-item").each(function () {
    $(this).find(".children-panel .child-items .item").eq(0).addClass("active");
    $(this).find(".children-panel .child-items-imgs .img").eq(0).fadeIn();
    $(this).hover(
      function () {
        $(this).addClass("active").siblings().removeClass("active");
        $(this).find(".children-panel").fadeIn();
        $(this).siblings().find(".children-panel").fadeOut();
      },
      function () {}
    );
    $(this)
      .find(".children-panel .child-items .item")
      .hover(function () {
        var index = $(this).index();
        $(this).addClass("active").siblings().removeClass("active");
        $(this).parent().siblings(".child-items-imgs").find(".img").eq(index).fadeIn().siblings().fadeOut();
      });
  });
}

function slider() {
  if ($(".banner-slider").length > 0) {
    var $slider = $(".banner-slider .slick-items");
    $('.banner-slider .slick-items:not(".slick-initialized")')
      .on("init", function (event, slick) {
        $(this).parent().show();
      })
      .slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
        dots: false,
        pauseOnHover: false,
        pauseOnFocus: false,
        focusOnSelect: false,
        fade: false, // Important to disable default fade effect
        nextArrow: "<button class='slick-next icon-arrow-left'></button>",
        prevArrow: "<button class='slick-prev icon-arrow-right'></button>",
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 767.5,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });

    document.querySelector(".banner-slider").addEventListener("wheel", function (e) {
      if (e.deltaX !== 0) {
        e.preventDefault();
        if (e.deltaX > 50) {
          $(".banner-slider .slick-items").slick("slickNext");
        } else if (e.deltaX < -50) {
          $(".banner-slider .slick-items").slick("slickPrev");
        }
      }
    });
    // Custom fade effect for multiple slides
    $(".banner-slider .slick-items").on("beforeChange", function (event, slick, currentSlide, nextSlide) {
      var slides = $(this).find(".slick-slide");
      slides.each(function (index, slide) {
        if (index >= nextSlide && index < nextSlide + slick.options.slidesToShow) {
          $(slide).addClass("slick-active");
        } else {
          $(slide).removeClass("slick-active");
        }
      });
    });

    // Initialize the first set of slides
    var slides = $(".banner-slider .slick-items").find(".slick-slide");
    slides.each(function (index, slide) {
      if (index < 4) {
        $(slide).addClass("slick-active");
      }
    });
    // jQuery(".banner-slider").on("afterChange", function (event, slick, currentSlide, nextSlide) {
    //   jQuery(".banner-slider  .slick-active").removeClass("move");
    //   setTimeout(function () {
    //     jQuery(".banner-slider   .slick-active").addClass("move");
    //   }, 600);
    // });
    // jQuery('.banner-slider .slick-active').addClass('move')
  }
  if ($(".featured-slider .slider-items").length > 0) {
    var $slider = $(".featured-slider .slider-items");
    var $currentSlide = $(".slick-pagation .current-num");
    var $totalSlides = $(".slick-pagation .total-num");

    // $slider.on('init', function(event, slick){
    //   // Debug message to ensure the init event is triggered
    //   var totalGroups = Math.ceil(slick.slideCount / slick.options.slidesToScroll);
    //   $totalSlides.text(totalGroups);
    // });

    // $slider.on('afterChange', function(event, slick, currentSlide){
    //   var currentGroup = Math.floor(currentSlide / slick.options.slidesToScroll) + 1;
    //   $currentSlide.text(currentGroup);
    // });

    $('.featured-slider .slider-items:not(".slick-initialized")').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: true,
      arrows: true,
      dots: false,
      pauseOnHover: false,
      pauseOnFocus: false,
      focusOnSelect: false,
      // centerMode: true,
      nextArrow: ".slick-nav .icon-small-next ",
      prevArrow: ".slick-nav .icon-small-prev ",
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });

    function updatePagination(slick) {
      var totalGroups = Math.ceil(slick.slideCount / slick.options.slidesToScroll);
      $totalSlides.text(totalGroups);
      var currentGroup = Math.floor(slick.currentSlide / slick.options.slidesToScroll) + 1;
      $currentSlide.text(currentGroup);
    }
    $slider.on("init", function (event, slick) {
      updatePagination(slick);
    });
    $slider.on("afterChange", function (event, slick, currentSlide) {
      updatePagination(slick);
    });

    $(window).on("resize", function () {
      $slider.slick("resize");
      updatePagination($slider.slick("getSlick"));
    });
    $(window).trigger("resize");

    document.querySelector(".featured-slider").addEventListener("wheel", function (e) {
      if (e.deltaX !== 0) {
        e.preventDefault();
        if (e.deltaX > 20) {
          $(".featured-slider .slider-items").slick("slickNext");
          console.log(2);
        } else if (e.deltaX < -20) {
          $(".featured-slider .slider-items").slick("slickPrev");
        }
      }
    });
  }
  if ($(".promo-collection-block").length > 0) {
    var $slider = $(".promo-collection-block .slick-items");
    $('.promo-collection-block .slick-items:not(".slick-initialized")').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: true,
      arrows: true,
      dots: false,
      pauseOnHover: false,
      pauseOnFocus: false,
      focusOnSelect: false,

      nextArrow: "<button class='slick-next icon-arrow-left'></button>",
      prevArrow: "<button class='slick-prev icon-arrow-right'></button>",
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
    document.querySelector(".promo-collection-block .slick-items").addEventListener("wheel", function (e) {
      if (e.deltaX !== 0) {
        e.preventDefault();
        if (e.deltaX > 50) {
          $(".promo-collection-block .slick-items").slick("slickNext");
        } else if (e.deltaX < -50) {
          $(".promo-collection-block .slick-items").slick("slickPrev");
        }
      }
    });
  }
  if ($(".product-info__image").length > 0) {
    var $smallItems = $('.product-info__image .slider-small-items');
  
    if ($smallItems.children().length > 4) {
      $smallItems.not(".slick-initialized").slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: false,
        arrows: true,
        dots: false,
        pauseOnHover: false,
        pauseOnFocus: false,
        focusOnSelect: false,
        vertical: true,
        verticalSwiping: true,
        prevArrow: "<button class='slick-prev icon-arrow-left'></button>",
        nextArrow: "<button class='slick-next icon-arrow-right'></button>",
        asNavFor: ".slider-large-items",
        swipeToSlide: true,
        touchMove: true,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              verticalSwiping: false,
              vertical: false,
              slidesToShow: 3,
            },
          },
        ],
      });

      var $slider = $(".product-info__image .slider-large-items");
      $slider.not(".slick-initialized").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        arrows: false,
        dots: false,
        pauseOnHover: false,
        pauseOnFocus: false,
        focusOnSelect: false,
        asNavFor: ".slider-small-items",
      });



    var currentSlide = $smallItems.slick("slickCurrentSlide");

    if (currentSlide === 0) {
      $smallItems.addClass("first-slide"); 
    } else {
      $smallItems.removeClass("first-slide");
  }

  $smallItems.on("afterChange", function () {
    var currentSlide = $smallItems.slick("slickCurrentSlide");
    if (currentSlide === 0) {
      $smallItems.addClass("first-slide"); 
    } else {
      $smallItems.removeClass("first-slide");
  }
  });


    $(".slider-small-items .slider-item").click(function () {
      var index = $(this).attr("data-slick-index");
      $(this).parents(".product-info__image--small").siblings().find(".slider-large-items").slick("slickGoTo", index);
    });

    document.querySelector(".product-info__image .slider-small-items").addEventListener("wheel", function (e) {
      if (e.deltaX !== 0) {
        e.preventDefault();
        if (e.deltaX > 20) {
          $(".product-info__image .slider-small-items").slick("slickNext");
          console.log(2);
        } else if (e.deltaX < -20) {
          $(".product-info__image .slider-small-items").slick("slickPrev");
        }
      }
    });
    } 

    else {
      var $slider = $(".product-info__image .slider-large-items");
      $slider.not(".slick-initialized").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        arrows: false,
        dots: false,
        pauseOnHover: false,
        pauseOnFocus: false,
        focusOnSelect: false,
      });

      $slider.on("afterChange", function (event, slick, currentSlide, nextSlide) {
        $(this).parent('.product-info__image--large').siblings('.product-info__image--small').find('.slider-item').eq(currentSlide).addClass('active').siblings().removeClass('active');
    });
    $(".slider-small-items .slider-item").eq(0).addClass('active');
      $(".slider-small-items .slider-item").click(function () {
        var index = $(this).index();
        $(this).parents(".product-info__image--small").siblings().find(".slider-large-items").slick("slickGoTo", index);
      });
    }




  }
  
  if ($(".heritage__slider-items").length > 0) {
 
    $(".heritage__slider-items .heritage__slider-item").each(function () {
      var $slider = $(this).find(".slider-items");
      $slider.slick({
        slidesToScroll: 1,
        slidesToShow: 3,
        infinite: false,
        arrows: false,
        dots: false,
        pauseOnHover: false,
        pauseOnFocus: false,
        focusOnSelect: false,

        speed: 500,
        swipeToSlide: true,
        variableWidth: true,
      });



      $slider.on("click", ".slick-slide", function (e) {
        e.stopPropagation();
        var index = $(this).data("slick-index");
        if ($slider.slick("slickCurrentSlide") !== index) {
          $slider.slick("slickGoTo", index);
        }
      });

      $(this).hover(function () {
        $(this).addClass("js-index");
      }, function () {
        $(this).removeClass("js-index");
      }) 

    });
    
  }
}

function click() {
  //  Header

  $(".header__nav-menu:not('.back')").click(function () {
    $(this).toggleClass("active");
    $(".header__nav-menu--inner").toggleClass("active");
    var $topBar = $(".header__top-bar");
    var topBarHeight = $topBar.innerHeight();

    if (!$topBar.hasClass("flag__close")) {
      if (!$topBar.hasClass("flag__sticky")) {
        if ($topBar.hasClass("flag")) {
          $topBar.css("margin-top", 0);
          $topBar.removeClass("flag");
        } else {
          $topBar.css("margin-top", -topBarHeight);
          $topBar.addClass("flag");
        }
      }
    }

    $("html, body").toggleClass("overflow_hidden");
  });

  $(".header__nav-menu.back").click(function () {
    $(".header__nav-menu").removeClass("active");
    $(".header__nav-menu--inner").removeClass("active");
    $("html, body").removeClass("overflow_hidden");
    $("html, body").removeClass("overflow_hidden");
    var $topBar = $(".header__top-bar");
    var topBarHeight = $topBar.innerHeight();

    if (!$topBar.hasClass("flag__close")) {
      if (!$topBar.hasClass("flag__sticky")) {
        if ($topBar.hasClass("flag")) {
          $topBar.css("margin-top", 0);
          $topBar.removeClass("flag");
        } else {
          $topBar.css("margin-top", -topBarHeight);
          $topBar.addClass("flag");
        }
      }
    }
  });
  $(".header__nav-menu--inner .pages .top-level-item.has-children").each(function () {
    $(this).click(function () {
      $(this).find(".children-panel").addClass("active");
    });
  });
  $(".header__nav-menu--inner  .children-panel .back").click(function (e) {
    e.stopPropagation();
    $(this).parents(".children-panel").removeClass("active");
  });


  $('.header__top-bar a').on('click', function(event) {
    if (this.pathname === window.location.pathname) {
      event.preventDefault();
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      if (target.length) {
        $('html, body').animate({
          scrollTop: target.offset().top
        }, 1000); 
      }
    }
});
  // banner scroll
  $(".scroll-down").click(function () {
    var scrollHeight = $(this).parents(".hero-banner").innerHeight();
    var headerHeight = $(window).width() > 991 ? 72 : 48;
    $("html,body").animate({ scrollTop: scrollHeight - headerHeight }, 800);
  });
  //  Top Bar
  $(".header__top-bar .icon-close").click(function () {
    var $topBar = $(this).parent();
    $topBar.addClass("flag__close");
    var topBarHeight = $topBar.innerHeight();
    $topBar.css("margin-top", -topBarHeight);
  });

  //  Filter
  $(".filter__sorts .item-title").click(function () {
    $(this).toggleClass("active").siblings().stop().slideToggle(300);
    $(this).parent().siblings().find(".item-title").removeClass("active").siblings(".filter-check").slideUp(300);
  });

  $(".filter__sorts").prepend('<div class="filter-title"> <h2>Filters</h2> </div>');
  $("#FacetsWrapperDesktop").append(`<div class="filter-mobile-bottom"> 
  <a class="apply-filters btn" href="javascript:;">
   <span>APPLY FILTERS</span>
   <div class="btn-stroke-top"></div>
   <div class="btn-stroke-bottom"></div>
    </a>
    </div> 

    `);
  $(".facets-wrapper").append(`<div class="icon-close"></div>`);

  $(".filter-block .clear").click(function () {
    $(".filter__sorts").find("input").prop("checked", false);
  });
  $(".filter-title").click(function () {
    $(".facets-wrapper").addClass("active");
    $("html, body").addClass("overflow-hidden");
  });
  $(".facets-wrapper .icon-close, .apply-filters").click(function () {
    $(".facets-wrapper").removeClass("active");
    $("html, body").removeClass("overflow-hidden");
  });
  //  Tabs
  $('.tab-content .faq-items').each(function () {
    $(this).find('.faq-item').eq(0).addClass('active').find('.drop-box').css('display',"block");
  })
  $(".tabs .tab-title").eq(0).addClass("active");
  $(".tab-content-box .tab-content").eq(0).addClass("active");
  $(".tab-content-box").height($(".tab-content-box .tab-content.active").height());
  var tabs = $(".tabs .tab-title");
  var tabContents = $(".tab-content-box .tab-content");
  tabContents.each(function () {
    var height = $(this).height();
    $(this).data("height", height);
  });

  tabs.click(function () {
    var i = $(this).index();
    $(this).addClass("active").siblings().removeClass("active");
    var dataHeight = tabContents.eq(i).data("height");
    tabContents.eq(i).addClass("active").siblings().removeClass("active");
    $(this).parent().siblings().height(dataHeight);
  });

  // Adjust on window resize
  $(window).resize(function () {
    // adjustHeight();

    var tabContents = $(".tab-content-box .tab-content");
    tabContents.each(function () {
      var height = $(this).height();
      $(this).data("height", height);
    });
    $(".tab-content-box").height($(".tab-content-box .tab-content.active").height());
  });

  // Faqs


  $(".faq-box .faq-item h3").click(function () {
    $(this).siblings().stop().slideToggle(300,function () {
      var height = $(this).parents('.tab-content').height();
      $(this).parents('.tab-content-box').height(height)
    }).parent().toggleClass("active");
    $(this).parent().siblings().removeClass("active").find(".drop-box").slideUp(300,function () {
      var height = $(this).parents('.tab-content').height();
      $(this).parents('.tab-content-box').height(height)
    });

  });

  $(".faq-lists .list h4").click(function () {
    $(this).siblings().stop().slideToggle(300).parent().toggleClass("active");
    $(this).parent().siblings().removeClass("active").find(".drop-box").slideUp(300);

    $(this).parents(".faq-item").siblings().find(".list").removeClass("active").find(".drop-box").slideUp(300);
  });

  // faq panel
  if ($(".faqs-panel").length > 0) {
    var $h2Elements = $(".faqs-panel .wrapper h2");
    var $h3Elements = $(".faqs-panel .wrapper .title h3");
    var $navLinksContainer = $(".quick-links");

    $h2Elements.each(function (i) {
      var $h2 = $(this);
      var text = $h2.text().trim();
      var href = text.replace(/[^\w]|_/g, "");

      $navLinksContainer.append(`
        <div class='quick-link'>
          <a href='javascript:;'>${text}</a>
          <ul></ul>
        </div>
      `);

      var $currentUl = $navLinksContainer.find(".quick-link").eq(i).find("ul");

      $h3Elements.each(function () {
        var $h3 = $(this);
        var spanText = $h3.next().text();
        var id = spanText.trim().replace(/[^\w]|_/g, "");

        if ($h3.text().trim() == text) {
          $h3.parent().attr("id", text + id);
          $currentUl.append(`
            <li><a href="#${text}${id}">${spanText}</a></li>
          `);
        }
      });
    });
    $navLinksContainer.on("click", ".quick-link li a", function (e) {
      e.preventDefault();
      if ($(".header__top-bar").hasClass("flag__sticky")) {
        var headerHeight = $(window).width() > 575 ? 120 : 96;
      } else {
        var headerHeight = $(window).width() > 575 ? 184 : 146;
      }
      var targetTop = $($(this).attr("href")).offset().top - headerHeight + 1;
      $("html, body").animate({ scrollTop: targetTop }, 800);
    });
  }

  $(".faqs-panel .quick-link>a").click(function () {
    $(this).parent().toggleClass("active").find("ul").slideToggle(300);
    $(this).parent().siblings().removeClass("active").find("ul").slideUp(300);
  });
  //  Search box
  $(".header__icon--search").click(function () {
    $(".search-modal").addClass("active");
  });
  $(".search-modal__close-button").click(function () {
    $(".search-modal").removeClass("active");
  });

  // $(".logo-system").each(function () {
  //   $(this).find(".logos").eq(0).addClass("active");
  //  $(this).find(".logos").each(function ( ) {
  //   var $logos = $(this);
  //   $logos.find('.logo').eq(0).addClass("active");
  //   });

  //   var logoBtns = $(this).find(".logo-btns");
  //   // $(this)
  //   //   .find(".logo-btns .logo-btn")
  //   //   .click(function () {
  //   //     var i = $(this).index();
  //   //    $(this).parent().siblings('.logos.active').find('.logo').eq(i).addClass("active").siblings().removeClass("active");
  //   //   });

  //   logoBtns.find(".control-bg-color").click(function () {
  //     $(this).addClass("active").siblings(".control-bg-color").removeClass("active");
  //   });
  //   logoBtns.find('.control-bg-color:not(".transparent")').click(function () {
  //     var backgroundColor = $(this).find("span").css("background-color");
  //     $(this).parents(".logo-system").css({ "background-color": "none", "background-color": backgroundColor }).removeClass("transparent");
  //   });
  //   logoBtns.find(".control-bg-color.transparent ").click(function () {
  //     $(this).parents(".logo-system").css({ "background-color": "none" }).addClass("transparent");
  //     $(this).parents('.logo-btns').siblings('.logos.has-bg').addClass('active').siblings('.logos').removeClass('active');
  //   });

  //   logoBtns.find(".control-bg-color.inside-red").click(function () {
  //     $(this).parents(".logo-system").css({ "background-color": "none" }).addClass("inside-red").removeClass("inside-white").removeClass("red");
  //     logo.eq(0).addClass("active").siblings().removeClass("active");
  //   });
  //   logoBtns.find(".control-bg-color.inside-white").click(function () {
  //     $(this).parents(".logo-system").css({ "background-color": "none" }).addClass("inside-white").removeClass("inside-red").removeClass("red");
  //     logo.eq(1).addClass("active").siblings().removeClass("active");
  //   });

  //   logoBtns.find(".control-bg-color.red").click(function () {
  //     if (!$(this).parents(".logo-system").hasClass("face")) {
  //       $(this).parents(".logo-system").addClass("red").removeClass("inside-white").removeClass("inside-red");
  //       logo.eq(1).addClass("active").siblings().removeClass("active");
  //     }
  //     $(this).parents('.logo-btns').siblings('.logos.transparent').addClass('active').siblings('.logos').removeClass('active');
  //   });
  //   logoBtns.find(".control-bg-color.white").click(function () {
  //     $(this).parents(".logo-system").removeClass("red").removeClass("inside-white").removeClass("inside-red");
  //     logo.eq(0).addClass("active").siblings().removeClass("active");
  //   });
  // });

  // Handle download link clicks
  $(".logo-download .download-link").click(function (e) {
    e.preventDefault(); // Prevent default anchor behavior

    var format = $(this).attr("class").split(" ")[1]; // Get format from class name
    var $logos = $(this).closest(".logo-download").siblings(".logos.active");

    var $activeLogo = $logos.find(".logo.active");

    var imageUrl = $activeLogo
      .find(".download-imgs ." + format)
      .text()
      .trim();
    console.log(imageUrl);
    if (imageUrl) {
      var filename = imageUrl.split("/").pop().split("?")[0];

      // Fetch the file and download it as a blob
      // console.log(filename);
      fetch(imageUrl)
        .then((response) => response.blob())
        .then((blob) => {
          var url = window.URL.createObjectURL(blob);
          var a = document.createElement("a");
          a.style.display = "none";
          a.href = url;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
        })
        .catch(() => alert("Failed to download file."));
    }
  });

  // Logos swatches
  $(".logo-system").each(function () {
    $(this).find(".logos").eq(0).addClass("active");

    if($(this).hasClass('wordmark')) {
      $(this).find(".logos.white").addClass("active").siblings().removeClass("active");
    }

    $(this).find(".logos").each(function () {
        var $logos = $(this);
        $logos.find(".logo").eq(0).addClass("active");
      });

    var logoBtns = $(this).find(".logo-btns");
    // $(this)
    //   .find(".logo-btns .logo-btn")
    //   .click(function () {
    //     var i = $(this).index();
    //     logo.eq(i).addClass("active").siblings().removeClass("active");
    //   });

    var logo = $(this).find('.logos .logo');
    

    logoBtns.find('.control-bg-color:not(".transparent")').click(function () {
      var backgroundColor = $(this).find("span").css("background-color");
      $(this).parents(".logo-system").css({ "background-color": "none", "background-color": backgroundColor }).removeClass("transparent");
    });
    logoBtns.find(".control-bg-color.transparent ").click(function () {
      $(this).parents(".logo-system").css({ "background-color": "none" }).addClass("transparent");
      $(this).parents(".logo-btns").siblings(".logos.has-bg").addClass("active").siblings(".logos").removeClass("active");

      // var $logos = $(this).parent().siblings(".logos.active");
      // handleLogoDownloadDisplay($logos);
    });
    logoBtns.find(".control-bg-color.white ").click(function () {
      // $(this).parents(".logo-system").css({ "background-color": "none" }).addClass("transparent");
      $(this).parents(".logo-btns").siblings(".logos.has-bg").removeClass("active").siblings(".logos").addClass("active");

      // var $logos = $(this).parent().siblings(".logos.active");
      // handleLogoDownloadDisplay($logos);
    });
    logoBtns.find(".control-bg-color.inside-red").click(function () {
      $(this).parents(".logo-system").css({ "background-color": "none" }).addClass("inside-red").removeClass("inside-white").removeClass("red");

      logo.eq(0).addClass("active").siblings().removeClass("active");
      $(this).parents(".logo-btns").siblings(".logos.transparent_insert_red").addClass("active").siblings(".logos").removeClass("active");

      // var $logos = $(this).parent().siblings(".logos.active");
      // handleLogoDownloadDisplay($logos);

    });
    logoBtns.find(".control-bg-color.inside-white").click(function () {
      $(this).parents(".logo-system").css({ "background-color": "none" }).addClass("inside-white").removeClass("inside-red").removeClass("red");
      logo.eq(1).addClass("active").siblings().removeClass("active");

      $(this).parents(".logo-btns").siblings(".logos.transparent").addClass("active").siblings(".logos").removeClass("active");
      

    });
    logoBtns.find(".control-bg-color.red").click(function () {

      if (!$(this).parents(".logo-system").hasClass("face")) {

        $(this).parents(".logo-system").addClass("red").removeClass("inside-white").removeClass("inside-red");
        logo.eq(1).addClass("active").siblings().removeClass("active");
        $(this).parents(".logo-btns").siblings(".logos.has-bg").addClass("active").siblings(".logos").removeClass("active");

      } else {
        $(this).parents(".logo-btns").siblings(".logos.transparent").addClass("active").siblings(".logos").removeClass("active");

      }
   
      // var $logos = $(this).parent().siblings(".logos.active");
      // handleLogoDownloadDisplay($logos);
    });
    logoBtns.find(".control-bg-color.white").click(function () {
      $(this).parents(".logo-system").removeClass("red").removeClass("inside-white").removeClass("inside-red");
      logo.eq(0).addClass("active").siblings().removeClass("active");
      $(this).parents(".logo-btns").siblings(".logos.white").addClass("active").siblings(".logos").removeClass("active");
      // handleLogoDownloadDisplay($logos);
    });

    logoBtns.find(".control-bg-color").click(function () {
      $(this).addClass("active").siblings(".control-bg-color").removeClass("active");
      var $logos = $(this).parent().siblings(".logos.active");
      handleLogoDownloadDisplay($logos);
    });
  });


  $('.images .logo-btns').each(function () { 
    $(this).siblings('.img_1').addClass("active");

    $(this).find(".control-bg-color").click(function () {
      var backgroundColor = $(this).find("span").css("background-color");
      var index = $(this).index();
      $(this).parents(".image").css({ "background-color": "none", "background-color": backgroundColor });
      $(this).parent().siblings('img').eq(index).addClass('active').siblings().removeClass('active');
      })
   });
  // Apply display logic on button click
  $(".logo-btn").click(function () {
    var $logos = $(this).parent().siblings(".logos");
    var i = $(this).index();
    var $logosActive = $(this).parent().siblings(".logos.active");
    $logos.each(function () {
      var $this = $(this);
      var logo = $this.find(".logo");
      logo.eq(i).addClass("active").siblings().removeClass("active");
    })
    
    handleLogoDownloadDisplay($logosActive);
 
 
  });

// download more files
  function downloadMultipleImages(imageUrls) {
    var zip = new JSZip();
  
    imageUrls.forEach(function(imageUrl, index) {
      // var filename = imageUrl.split("/").pop().split("?")[0];
      fetch(imageUrl)
        .then(response => response.blob())
        .then(blob => {
          zip.file(`image-${index + 1}.eps`, blob);
          
          if (index === imageUrls.length - 1) {
            zip.generateAsync({type:"blob"})
              .then(function(content) {
                var link = document.createElement('a');
                link.href = URL.createObjectURL(content);
                link.download = 'images.zip'; //
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              });
          }
        });
    });
  }
$('.imagery-box .download-link.eps').click(function() {
    var ele;
    $(this).parent().siblings('.downloads-imgs').find('.eps').each(function () {
      ele = $(this).text().trim();
    })  

    if (!ele) {
      $(this).hide();
      return false;
  }
  var link = document.createElement('a');
  link.href = ele;
  link.download = 'eps.zip';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
})

  // Function to handle display logic for .logo-download elements
  function handleLogoDownloadDisplay($context) {
    var $activeLogo = $context.find(".logo.active");
    var $downloadImgs = $activeLogo.find(".download-imgs");

    var $logoDownload = $activeLogo.parent().siblings(".logo-download");

    if ($downloadImgs.length === 0 || $downloadImgs.html().trim() === "") {
      $logoDownload.css("display", "none");
    } else {
      $logoDownload.css("display", "flex");

      $downloadImgs.find("div").each(function () {
        var $this = $(this);
        var attrClass = $this.attr("class");
        $logoDownload.css("display", "flex");

        var $downloadLinks = $logoDownload.find(".download-link");
        $downloadLinks.css("display", "none");

        $downloadImgs.find("div").each(function () {
          var $downloadImg = $(this);
          var attrClass = $downloadImg.attr("class");
          $logoDownload.find("." + attrClass).css("display", "flex");
        });
      });
    }
  }

  $(".logo-system .logos.active").each(function () {
    var $logosContainer = $(this);
    var $activeLogo = $logosContainer.find(".logo.active");

    var $downloadImgs = $activeLogo.find(".download-imgs");
    var $logoDownload = $activeLogo.parent().siblings(".logo-download");

    if ($downloadImgs.length === 0 || $downloadImgs.html().trim() === "") {
      $logoDownload.css("display", "none");
    } else {
      $logoDownload.css("display", "flex");

      var $downloadLinks = $logoDownload.find(".download-link");
      $downloadLinks.css("display", "none");

      $downloadImgs.find("div").each(function () {
        var $downloadImg = $(this);
        var attrClass = $downloadImg.attr("class");
        $logoDownload.find("." + attrClass).css("display", "flex");
      });
    }
  });
  $("body").on("click", ".top-level-item .item-title", function () {
    if ($("#contact").length) {
      var url = $(this).attr("href").split("#")[1];
      if (url === "contact") {
        location.reload();
      }
    }
  });

  $(window).on("load", function () {
    if ($("#contact").length) {
      var url = window.location.href.split("#")[1];
      if (url === "contact") {
        var headerH = 136;
        var offsetTop = $("#contact").offset().top - headerH;
        $("html,body").animate({ scrollTop: offsetTop }, 500);
      }
    }
  });

  // $('.contact-form form ').change(function () {
  //   // e.preventDefault();
  //   if (!$('.check-box input').prop('checked')) {
  //     // $('.check-box ').addClass('error');
  //     console.log(1);
  //   }
  // });

  // $(".font-download").each(function () {
  //   var $this = $(this);

  //   function downloadFont(format) {
  //     var fontUrl;
  //     if ($(".text-font").hasClass("bold")) {
  //       fontUrl = "../assets/FusionGroteskTrial-Bold." + format;
  //     } else {
  //       fontUrl = "../assets/FusionGroteskTrial-Regular." + format;
  //     }

  //     var link = document.createElement("a");
  //     link.style.display = "none";
  //     link.href = fontUrl;
  //     link.download = "FusionGroteskTrial." + format;
  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);
  //   }

  //   $this.find(".download-link").click(function () {
  //     var format = $(this).data("format");
  //     downloadFont(format);
  //   });
  // });

  function downloadFile(url, fileName) {
    fetch(url, {
      method: "get",
      mode: "no-cors",
      referrerPolicy: "no-referrer",
    })
      .then((res) => res.blob())
      .then((res) => {
        const aElement = document.createElement("a");
        aElement.setAttribute("download", fileName);
        const href = URL.createObjectURL(res);
        aElement.href = href;
        aElement.setAttribute("target", "_blank");
        aElement.click();
        URL.revokeObjectURL(href);
      });
  }

  $(".color-item").each(function () {
    $(this).find(".item-info").eq(0).addClass("active");
    // if ($(this).find(".item-current span").attr("style") == "--bg-c: #fff") {
    //   // $(this).addClass("border");
    // }
    var swatch = $(this).find(".item-swatch");
    swatch.find("span").hover(function () {
      var styleColor = $(this).attr("style");
      var index = $(this).index();
      $(this).parent().siblings().find("span").attr("style", styleColor);
      $(this).parents(".color-item").find(".item-info").eq(index).addClass("active").siblings().removeClass("active");
    });
  });

  if (!$(".faq-sec").hasClass("privacy-policy")) {
    var $h3Elements = $(".faq-sec .faq-item  h3");
    var $navLinksContainer = $(".faq-nav-links");
    var headerHeight = $(window).width() > 575 ? 112 : 68;
    $navLinksContainer.find(".faq-link").each(function () {
      $(this).attr(
        "href",
        "#" +
          $(this)
            .text()
            .trim()
            .replace(/[^\w]|_/g, "")
      );
    });
    $h3Elements.each(function () {
      var id = $(this)
        .text()
        .trim()
        .replace(/[^\w]|_/g, "");
      $(this).parent().attr("id", id);
      // $navLinksContainer.append("<a class='faq-link' href='#" + id + "'>" + $(this).text().trim() + "</a>");
    });
    $(window).scroll(function () {
      var scrollTop = $(this).scrollTop();
      var headerHeight = $(window).width() > 575 ? 112 : 68;
      $h3Elements.parent().each(function () {
        var $this = $(this);
        var top_H = $this.offset().top - headerHeight;

        if (top_H <= scrollTop) {
          $(".faq-link").removeClass("active");
          $navLinksContainer.find("a[href='#" + $this.attr("id") + "']").addClass("active");
        }
      });
    });
    $navLinksContainer.on("click", ".faq-link", function (e) {
      e.preventDefault();
      if ($(".header__top-bar").hasClass("flag__sticky")) {
        var headerHeight = $(window).width() > 575 ? 112 : 68;
      } else {
        var headerHeight = $(window).width() > 575 ? 176 : 118;
      }
      var targetTop = $($(this).attr("href")).offset().top - headerHeight + 1;
      $("html, body").animate({ scrollTop: targetTop }, 800);
    });
  } else {
    var $h2Elements = $(".faq-sec .faq-items h2");
    var $navLinksContainer = $(".faq-nav-links");
    var headerHeight = $(window).width() > 575 ? 72 : 48;
    $h2Elements.each(function (index) {
      var text = $(this).text();
      var html = $(this)
        .html()
        .replace(/[^\w]|_/g, "");

      $(this).attr("id", html);

      $navLinksContainer.append("<a class='faq-link' href='#" + html + "'>" + $(this).text().trim() + "</a>");
    });
    $(window).scroll(function () {
      var scrollTop = $(this).scrollTop();
      var headerHeight = $(window).width() > 575 ? 104 : 80;
      $h2Elements.each(function () {
        var $this = $(this);
        var top_H = $this.offset().top - headerHeight;

        if (top_H <= scrollTop) {
          $(".faq-link").removeClass("active");
          $navLinksContainer.find("a[href='#" + $this.attr("id") + "']").addClass("active");
        }
      });
    });
    $navLinksContainer.on("click", ".faq-link", function (e) {
      e.preventDefault();
      if ($(".header__top-bar").hasClass("flag__sticky")) {
        var headerHeight = $(window).width() > 575 ? 104 : 80;
      } else {
        var headerHeight = $(window).width() > 575 ? 168 : 130;
      }
      var targetTop = $($(this).attr("href")).offset().top - headerHeight + 1;
      $("html, body").animate({ scrollTop: targetTop }, 800);
    });
  }
  //  read our story
  $(".text-and-image a").click(function () {
    var headerHeight = $(window).width() > 575 ? 112 : 68;
    $("html, body").animate({ scrollTop: $(this.hash).offset().top - headerHeight + 1 });
  });
  //  Slider
  $(".heritage__slider-nav .slider-link").eq(0).addClass("active");

  $(".heritage__slider-items .heritage__slider-wrapper").eq(0).addClass("active");
  $(".heritage__slider-nav .slider-link").click(function () {
    $(this).addClass("active").siblings().removeClass("active");
    var i = $(this).index();
    $(".heritage__slider-items .heritage__slider-wrapper").eq(i).addClass("active").siblings().removeClass("active");
  });

  $('.heritage__slider-nav .slider-link').each(function (i) {
    var $this =  $(this);
    $('.heritage__slider-wrapper ').eq(i).find('.label').text($this.text());   
  })

  //  form select
  $(".select-input input").click(function () {
    $(this).siblings("ul").stop().slideToggle(300).parent().toggleClass("active");
    $(this).parents(".form-input").siblings().find(".select-input").removeClass("active").find("ul").slideUp(300);
  });
  $(".select-input ul li").click(function () {
    var val = $(this).text();
    $(this).parent().slideUp(300).siblings("input").val(val);
    $(this).parents(".select-input").removeClass("active");
  });

  //positioning-block
  $(".positioning-block h2").html(function (_, html) {
    var tempDiv = $("<div>").html(html);
    tempDiv.contents().each(function () {
      if (this.nodeType === 3) { 
        this.nodeValue = this.nodeValue.replace(/\s+/g, " ").trim();
      } else if (this.nodeType === 1) { 
        var $this = $(this);
        if ($this.is("video")) {
       
          var src = $this.attr("src");
          if (src) {
            $this.attr("src", src);
          }
        }
      }
    });
    return tempDiv.html();
  });
  
  selfBlur(jQuery);

  function selfBlur($) {
    $("body").on("click", function (e) {
      var _pop = $(".pop-up .content");

      if (!_pop.is(e.target) && _pop.has(e.target).length === 0) {
        jQuery(".pop-up").removeClass("active");
      }
      var _select1 = $(".select .select-input");
      var _select2 = $(".reason .select-input");
      if (!_select1.is(e.target) && _select1.has(e.target).length === 0) {
        $(".select .select-input").removeClass("active").find("ul").slideUp(300);
      }
      if (!_select2.is(e.target) && _select2.has(e.target).length === 0) {
        $(".reason .select-input").removeClass("active").find("ul").slideUp(300);
      }
    });
  }
}
function stickyNav() {
  var h2Elements = $(".faq-content .faq-items h2");
  var headerHeight = $(".header").innerHeight();
  h2Elements.each(function (index) {
    var html = $(this)
      .html()
      .replace(/[^\w]|_/g, "");

    $(this).attr("id", html);
    var $navLink = $(".faq-nav__links .faq-link").eq(index);
    $navLink.attr("href", "#" + html);
  });
  $(window).scroll(function () {
    var scrollTop = $(window).scrollTop();
    var headerHeight = $(".header").innerHeight();
    $(".faq-nav__links .faq-link").each(function () {
      var $this = $(this);
      var top_H = $(this.hash).offset().top;
      if (top_H - headerHeight <= scrollTop) {
        $(".faq-nav__links .faq-link").removeClass("active");
        $this.addClass("active");
      }
    });
  });
  $(".faq-nav-links  .faq-link").click(function () {
    $("html,body").animate({ scrollTop: $(this.hash).offset().top - headerHeight + 1 }, 800);
  });
}
function file() {
  if ($("#drop-area").length) {
    const dropArea = document.getElementById("drop-area");
    dropArea.addEventListener("dragover", function (e) {
      e.stopPropagation();
      e.preventDefault();
      e.dataTransfer.dropEffect = "copy";
    });
    dropArea.addEventListener("drop", function (e) {
      e.stopPropagation();
      e.preventDefault();

      const files = e.dataTransfer.files;
      handleFiles(files);
    });

    dropArea.addEventListener("click", function (e) {
      document.getElementById("file-upload").click();
    });
    document.getElementById("file-upload").addEventListener("change", function (e) {
      const files = e.target.files;
      handleFiles(files);
    });
    function handleFiles(files) {
      const fileNames = Array.from(files)
        .map((file) => file.name)
        .join(", ");
      $(".file-name").text(fileNames);
    }
    $(".delete").click(function (e) {
      $(".file-name").text("");
      e.stopPropagation();
    });
  }
}
function copyUrl(id) {
  jQuery("body").after("<input id='copyVal'></input>");
  var text = id;
  var input = document.getElementById("copyVal");
  input.value = text;
  input.select();
  input.setSelectionRange(0, input.value.length);
  document.execCommand("copy");
  jQuery("#copyVal").remove();
}

function dragMoveX(container) {
  var flag;
  var downX;
  var scrollLeft;

  $(document.body).on("mousedown", container, function (event) {
    flag = true;
    downX = event.clientX;
    scrollLeft = $(this).scrollLeft();
  });

  $(document).on("mousemove", function (event) {
    if (flag) {
      var moveX = event.clientX;
      var scrollX = moveX - downX;
      // console.log("moveX" + moveX);
      // console.log("scrollX" + scrollX);
      if (scrollX < 0 && scrollLeft > 0) {
        $(container).scrollLeft(scrollLeft - scrollX);
      } else {
        $(container).scrollLeft(scrollLeft - scrollX);
      }
    }
  });

  $(document).on("mouseup", function () {
    flag = false;
  });

  $(container).on("mouseleave", function (event) {
    // flag = false;
    if (event.pageX < 0 || event.pageX > document.body.offsetWidth) {
      flag = false;
    }
  });
}
function giveMore(button, targetUl, showNumber, loadNumber, speed) {
  let list = showNumber;
  const row = jQuery(targetUl);

  row.find(">.item,.card").hide();
  row.find(".item:lt(" + list + ")").show();

  $("body").on("click", button, function () {
    const items = $(this).siblings(".items").find(".item");
    const sum = items.length;

    if ($(this).hasClass("read-more")) {
      if ($(this).hasClass("active")) {
        $(this).text("read more");
        items.slice(showNumber).slideUp(speed ? speed : 400);
        $(this).removeClass("active");
      } else {
        $(this).text("read less");
        items.slideDown(speed ? speed : 400);
        $(this).addClass("active");
      }
    } else {
      list += loadNumber;
      items.slice(0, list).slideDown(speed ? speed : 400);
    }
  });
}

var $ = jQuery.noConflict();
jQuery(document).ready(function () {
  $('.hero-banner h1').addClass('wowo fadeInUp delay-in-3');
  wowo();
  scroll();
  slider();
  video();
  // dragMoveX(".ms-redheads-block .content h2");
  hoverFun();
  click();
  file();
  resizeWindow();
  cookie();
  giveMore(".read-more", ".filte__results-text .items", 1);
  dataOrder();
  jQuery(window).on("load", function () {
    var str = location.href.split("#")[1];
    if (str == "cart-open") {
      $(".drawer ").addClass("active");
    }
  });
  jQuery(window).scroll(function () {
    wowo();
  });
  $('section').each(function () {
    var $this =  $(this);
    if($this.find('.app-wrap').length) {
      $this.addClass('js-insta');
    }
    if($this.find('.instagram-feed-wrap').length) {
      $this.find('.img-wave').show();
    }
  })
  $('.shopify-section').each(function () {
    var $this =  $(this);
    if($.trim($this.html()) === "") {
      $this.remove();
    }
  });
  jQuery(window).resize(function () {
    // if ($(window).width() < 991) {
    //   giveMore(".view-more", ".banner__text-items .items", 1);
    // }
  });
});
